import { z } from 'zod/v3';

/**
 * 검색 자동완성 (MarketSearchAutoCompletionResponse)
 */
export const searchAutoCompletionSchema = z.object({
  /** 매칭 스코어 */
  score: z.number(),
  /** 매칭된 키워드 */
  suggestedKeyword: z.string(),
});
export type SearchAutoCompletion = z.infer<typeof searchAutoCompletionSchema>;

/**
 * 최근 검색어 (RecentlySearchKeywordResponse)
 */
export const recentSearchKeywordSchema = z.object({
  /** 키워드 */
  keyword: z.string(),
  /** 검색 시각 (ISO-8601) */
  searchTime: z.string(),
});
export type RecentSearchKeyword = z.infer<typeof recentSearchKeywordSchema>;

// 검색 상품 목록 응답(CursorPagedResponseMarketSelectProductResponseV2)은
// market-products 의 cursorPagedMarketProductsSchema 와 동일 DTO 이므로 재사용한다.
